import * as React from 'react';
export const arrowLeftSvg = React.forwardRef(function arrowLeftSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.381 1.381A.875.875 0 1 1 7.62 2.62L3.112 7.125H15a.875.875 0 1 1 0 1.75H3.112l4.507 4.506A.875.875 0 1 1 6.38 14.62l-6-6a.872.872 0 0 1 0-1.238l6-6Z',
    }),
  );
});
arrowLeftSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowLeft = {
  category: 'icon',
  colorable: true,
  name: 'arrowLeft',
  svg: arrowLeftSvg,
};
